import {
  experimental_streamedQuery as streamedQuery,
  keepPreviousData,
  QueryClient,
  QueryClientProvider,
  queryOptions,
  useInfiniteQuery,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query"

import { retryOnlyServerErrors } from "./apiErrors"

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Keep all re-fetches disabled by default.
      // Enable what's needed. Some cases like Infinite-loading tables can get weird otherwise.
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      // See utils/apiErrors for what this does and does not retry.
      retry: retryOnlyServerErrors(3),
    },
  },
})

export const ReactQueryProvider = ({ children }) => {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}

ReactQueryProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export const useReactQueryClient = () => useQueryClient()

export { keepPreviousData, queryOptions, streamedQuery, useInfiniteQuery, useMutation, useQuery }

const testQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
})

export const MockReactQueryProvider = ({ children }) => {
  return <QueryClientProvider client={testQueryClient}>{children}</QueryClientProvider>
}

export const clearTestQueryCache = () => testQueryClient.clear()

MockReactQueryProvider.propTypes = {
  children: PropTypes.node.isRequired,
}
